import { Switch } from "@/components/ui/switch.tsx";
import { clsx } from "clsx";
import { CSSProperties, PropsWithChildren } from "react";

export interface CapabilityCardProps {
  className?: string;
  title: string;
  description: string;
  cost?: number;
  status: boolean;
  disabled?: boolean;
  onToggle?: (enabled: boolean) => void;
  style?: CSSProperties;
}

export const CAPABILITY_CARD_COLORS = [
  "#9C85E4",
  "#1589E6",
  "#00F0DC",
  "#A0E485",
  "#8FE615",
  "#FF7373",
  "#FFE373",
  "#FFB273",
  "#FFAEF1",
  "#FF73C5",
  "#99B700",
  "#AEFAFF",
  "#97A3FF",
];

export function CapabilityCard({
  className,
  title,
  description,
  cost,
  status,
  disabled,
  onToggle,
  style,
  children,
}: PropsWithChildren<CapabilityCardProps>) {
  return (
    <div
      className={clsx(
        "rounded-lg border data-[enabled=true]:border-[--color] p-4 flex flex-col justify-between",
        className,
      )}
      data-enabled={status}
      style={{
        ...style,
        boxShadow: status ? "0px 0px 40px -12px var(--color)" : undefined,
      }}
    >
      <div>
        <div className="flex justify-between items-center mb-2">
          <h3 className="font-bold text-[--color] text-sm uppercase tracking-wider">
            {title}
          </h3>
          {onToggle ? (
            <Switch
              className="*:bg-[#F7F7F7] data-[state=checked]:*:bg-background data-[state=checked]:bg-[--color] data-[state=unchecked]:bg-[#3C3C3CA8]"
              checked={status}
              disabled={disabled}
              onCheckedChange={(checked) => onToggle(checked)}
            />
          ) : null}
        </div>
        <p className="text-muted-foreground text-sm">{description}</p>
      </div>
      {cost ? (
        <div className="text-muted-foreground text-xs mt-2">
          Cost per use: <span className="font-bold">{cost} credits</span>
        </div>
      ) : null}
      {children}
    </div>
  );
}
